import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../constants/common'
import {
  BuildingMultiSelect,
  BuildingSelectFormikField,
} from '../../../../Building'
import { FieldStackedLabel } from '../../../../Field'
import { FlatMultiSelect, FlatSelectFormikField } from '../../../../Flat'
import { FormFieldsContainer } from '../../../../Form'
import {
  EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING,
  EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT,
} from '../EmailCopyToEntityFilterModal.constants'

import {
  filterEmailCopyToEntityFilterModalFieldsFlatOptions,
  getEmailCopyToEntityFilterModalFieldsFlatApiParams,
  getEmailCopyToEntityFilterModalFieldsFlats,
  toEmailCopyToEntityFilterModalFieldsFlatSelectItems,
} from './EmailCopyToEntityFilterModalFields.utils'

function EmailCopyToEntityFilterModalFields() {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  const buildings =
    values[EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING]
  const flats = values[EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT]

  const flatApiParams =
    getEmailCopyToEntityFilterModalFieldsFlatApiParams(buildings)

  function handleChangeBuilding(nextBuildings = EMPTY_LIST) {
    if (nextBuildings.length === 0) {
      if (flats.length > 0) {
        setFieldValue(
          EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT,
          EMPTY_LIST
        )
      }

      return
    }

    const nextFlats = filterEmailCopyToEntityFilterModalFieldsFlatOptions({
      [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING]: nextBuildings,
      [EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT]: flats,
    })

    if (nextFlats.length !== flats.length) {
      setFieldValue(
        EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT,
        nextFlats
      )
    }
  }

  const disabledFlatField = buildings.length === 0

  return (
    <FormFieldsContainer>
      <BuildingSelectFormikField
        multi
        Field={FieldStackedLabel}
        Select={BuildingMultiSelect}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t(
                'Email.EmailCopyToEntityFilterModalBuildingFieldPlaceholderKey'
              ),
            },
          },
        }}
        emptyValue={EMPTY_LIST}
        fieldComponentProps={{
          label: t('Email.EmailCopyToEntityFilterModalBuildingFieldLabelKey'),
          shouldAdaptToMobileScreen: true,
        }}
        name={EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_BUILDING}
        onChange={handleChangeBuilding}
        onClear={handleChangeBuilding}
      />
      <FlatSelectFormikField
        multi
        Field={FieldStackedLabel}
        Select={FlatMultiSelect}
        apiParams={flatApiParams}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t(
                'Email.EmailCopyToEntityFilterModalFlatFieldPlaceholderKey'
              ),
            },
          },
        }}
        disabled={disabledFlatField}
        emptyValue={EMPTY_LIST}
        fieldComponentProps={{
          label: t('Email.EmailCopyToEntityFilterModalFlatFieldLabelKey'),
          shouldAdaptToMobileScreen: true,
        }}
        getData={getEmailCopyToEntityFilterModalFieldsFlats}
        name={EMAIL_COPY_TO_ENTITY_FILTER_MODAL_FIELD_NAME_FLAT}
        tooltip={
          disabledFlatField ? t('Email.SelectBuildingValueTooltipKey') : null
        }
        toPreparedItems={toEmailCopyToEntityFilterModalFieldsFlatSelectItems}
      />
    </FormFieldsContainer>
  )
}

export default EmailCopyToEntityFilterModalFields
